<div>
  <button
    *ngIf="canModifyDiscussion"
    type="button"
    class="btn btn-primary invite-to-discussion-button"
    (click)="inviteToDiscussionModal.show()"
  >
    <i class="icofont icofont-plus"></i>
    <i class="icofont icofont-user-alt-2"></i>
    Invite to panel
  </button>

  <!-- Discussion-invites-modal -->
  <invite-to-discussion-modal
    #inviteToDiscussionModal
    [discussion]="discussion"
    [hideFooter]="true"
  >
  </invite-to-discussion-modal>
  <!-- Discussion-invites-modal -->
</div>
